import { render, staticRenderFns } from "./start-trading.vue?vue&type=template&id=392aabca&scoped=true&"
import script from "./start-trading.vue?vue&type=script&lang=js&"
export * from "./start-trading.vue?vue&type=script&lang=js&"
import style0 from "./start-trading.vue?vue&type=style&index=0&id=392aabca&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392aabca",
  null
  
)

export default component.exports